export default __webpack_public_path__ + "static/gantmodern-bold-495b6a2c1d9195babe9f5b187281d0d4.woff2";